module.exports = __webpack_public_path__ + "img/usuario_padrao.266f978a.png";